/* CASH REPORT — THE MONTHLY CASH PLAN (Template 2), 2026-10-25. Replaces the 13 Weeks Cash Plan (Jay Sung, 21/10:
   "change to monthly"). Codes (SGD, USD, KRW, entity codes, GROUP) stay as they are. */
const en = {
  typeWhole: "Type whole {{ccy}}; the sheet shows thousands.",
  r_opFull: "Net increase (decrease) in cash - Operation",
  r_fiFull: "Net increase (decrease) in cash - Finance & Investment",
  total: "Total",
  ratesAsOf: "(as of {{date}}) Exchange Rates:",
  groupHeading: "Cash forecast for Helinox Group",
  beginInv: "Beginning inventory",
  tourTabsT: "One tab per sheet",
  tourTabsB: "As in the group cash forecast workbook: Group CF first, then each entity's own sheet, in its own currency and lines.",
  planLine: "Plan filed for {{week}} (week ending {{end}}) · {{first}} – {{last}}",
  rateLine: "Converted at NetSuite's rate of {{date}}",
  rateFallback: "Set up's rate of {{week}} used where NetSuite had none that day",
  groupTitle: "Group cash forecast",
  unitK: "Thousands of {{base}}",
  groupNone: "No entity has an agreed plan up to this week yet — the forecast shows once a Reviewer agrees one.",
  groupCount: "{{n}} of {{of}} entities planned",
  r_begin: "Beginning cash",
  r_net: "Net increase (decrease) in cash",
  r_op: "– Operation",
  r_fi: "– Finance & Investment",
  r_end: "Ending cash",
  r_in: "Cash in",
  r_out: "Cash out",
  from: "From the plan of {{week}}",
  fromOlder: "This week's plan is not agreed yet — read from {{week}}",
  noPlan: "No agreed plan",
  rateMissing: "No NetSuite rate for {{ccy}} — left out of the group",
  showLines: "Show its lines",
  hideLines: "Hide its lines",
  inCcy: "In {{ccy}}, whole amounts",
  h_line: "Line",
  h_remarks: "Remarks",
  memo: "memo, not counted",
  worked: "Worked out",
  standardFormat: "{{entity}} has no sheet of its own in the group cash forecast yet — the standard lines are used.",
  chartEnd: "Ending cash by month — {{who}}",
  chartEndSub: "Thousands of {{base}}, the group's ending cash month by month",
  chartNet: "Where the change comes from — {{who}}",
  chartNetSub: "Operation and Finance & Investment, thousands of {{base}}",
  chartNone: "Nothing agreed to draw yet.",
  formBeginHint: "The cash at the start of {{month}}. Every later month begins where the one before ends.",
  formFromPrior: "Pre-filled from your plan of {{week}} — update what has moved.",
  formNoPrior: "No earlier plan to start from.",
  panelHeading: "Plan of {{week}}",
  listHint: "Each entity's latest agreed plan up to this week. A plan comes in through Submit (Template 2) and is agreed in Approval.",
  tourGroupT: "The group cash forecast",
  tourGroupB: "Every entity's plan, month by month, at one NetSuite month-end rate per currency, and the group total on top. Pick SGD, USD or KRW above; figures are in thousands.",
  tourEntityT: "Each entity",
  tourEntityB: "Press an entity to see its own lines in its own currency, as it filled them in. A plan the Reviewer has not agreed yet does not count — the last agreed one is read and the row says which.",
  tourChartsT: "Charts",
  tourChartsB: "The group's ending cash month by month, and where each month's change comes from — Operation against Finance & Investment.",
};
const ko = {
  typeWhole: "{{ccy}} 원 단위로 입력하세요. 시트에는 천 단위로 표시됩니다.",
  r_opFull: "현금 순증감 - 영업",
  r_fiFull: "현금 순증감 - 재무 및 투자",
  total: "합계",
  ratesAsOf: "({{date}} 기준) 환율:",
  groupHeading: "Helinox 그룹 현금 예측",
  beginInv: "기초 재고",
  tourTabsT: "시트별 탭",
  tourTabsB: "그룹 현금 예측 파일과 같이 Group CF가 먼저, 이어서 각 법인의 시트가 자체 통화와 항목으로 표시됩니다.",
  planLine: "{{week}} 계획 (주 마감 {{end}}) · {{first}} – {{last}}",
  rateLine: "NetSuite {{date}} 환율로 환산",
  rateFallback: "그날 NetSuite 환율이 없는 통화는 {{week}} Set up 환율 사용",
  groupTitle: "그룹 현금 예측",
  unitK: "{{base}} 천 단위",
  groupNone: "이번 주까지 동의된 계획이 있는 법인이 없습니다 — Reviewer가 동의하면 예측이 표시됩니다.",
  groupCount: "{{of}}개 법인 중 {{n}}개 계획 제출",
  r_begin: "기초 현금",
  r_net: "현금 순증감",
  r_op: "– 영업",
  r_fi: "– 재무 및 투자",
  r_end: "기말 현금",
  r_in: "현금 유입",
  r_out: "현금 유출",
  from: "{{week}} 계획 기준",
  fromOlder: "이번 주 계획은 아직 동의되지 않음 — {{week}} 계획 기준",
  noPlan: "동의된 계획 없음",
  rateMissing: "{{ccy}}의 NetSuite 환율 없음 — 그룹 합계에서 제외",
  showLines: "항목 보기",
  hideLines: "항목 숨기기",
  inCcy: "{{ccy}}, 원 단위",
  h_line: "항목",
  h_remarks: "비고",
  memo: "참고용, 합계 제외",
  worked: "자동 계산",
  standardFormat: "{{entity}}은(는) 그룹 현금 예측에 자체 시트가 아직 없어 표준 항목을 사용합니다.",
  chartEnd: "월별 기말 현금 — {{who}}",
  chartEndSub: "{{base}} 천 단위, 그룹 월별 기말 현금",
  chartNet: "변동 요인 — {{who}}",
  chartNetSub: "영업 vs 재무 및 투자, {{base}} 천 단위",
  chartNone: "아직 동의된 수치가 없습니다.",
  formBeginHint: "{{month}} 초의 현금입니다. 이후 각 월은 전월 기말에서 시작합니다.",
  formFromPrior: "{{week}} 계획에서 미리 채움 — 변동된 부분을 수정하세요.",
  formNoPrior: "이전 계획이 없습니다.",
  panelHeading: "{{week}} 계획",
  listHint: "이번 주까지 각 법인의 최신 동의 계획입니다. 계획은 Submit(Template 2)으로 들어오고 Approval에서 동의됩니다.",
  tourGroupT: "그룹 현금 예측",
  tourGroupB: "각 법인의 계획을 월별로, 통화별 NetSuite 월말 환율 하나로 환산하여 위에 그룹 합계를 표시합니다. 위에서 SGD, USD, KRW를 선택하세요. 천 단위입니다.",
  tourEntityT: "법인별",
  tourEntityB: "법인을 누르면 입력한 그대로 자체 통화와 항목으로 볼 수 있습니다. Reviewer가 아직 동의하지 않은 계획은 반영되지 않으며, 마지막으로 동의된 계획을 읽고 어떤 계획인지 표시합니다.",
  tourChartsT: "차트",
  tourChartsB: "그룹의 월별 기말 현금과 매월 변동 요인 — 영업 vs 재무 및 투자.",
};
const vi = {
  typeWhole: "Nhập số nguyên {{ccy}}; sheet hiển thị theo nghìn.",
  r_opFull: "Tăng (giảm) tiền thuần - Hoạt động kinh doanh",
  r_fiFull: "Tăng (giảm) tiền thuần - Tài chính & Đầu tư",
  total: "Tổng",
  ratesAsOf: "(tại ngày {{date}}) Tỷ giá:",
  groupHeading: "Dự báo tiền mặt của Helinox Group",
  beginInv: "Tồn kho đầu kỳ",
  tourTabsT: "Mỗi sheet một tab",
  tourTabsB: "Giống file dự báo tiền mặt của Group: Group CF trước, rồi sheet riêng của từng pháp nhân, theo tiền tệ và các dòng của nó.",
  planLine: "Kế hoạch nộp cho {{week}} (tuần kết thúc {{end}}) · {{first}} – {{last}}",
  rateLine: "Quy đổi theo tỷ giá NetSuite ngày {{date}}",
  rateFallback: "Dùng tỷ giá Set up của {{week}} cho tiền tệ NetSuite không có ngày đó",
  groupTitle: "Dự báo tiền mặt của Group",
  unitK: "Nghìn {{base}}",
  groupNone: "Chưa có pháp nhân nào có kế hoạch được đồng ý tính đến tuần này — dự báo sẽ hiện khi Reviewer đồng ý.",
  groupCount: "{{n}} / {{of}} pháp nhân đã lập kế hoạch",
  r_begin: "Tiền đầu kỳ",
  r_net: "Tăng (giảm) tiền thuần",
  r_op: "– Hoạt động kinh doanh",
  r_fi: "– Tài chính & Đầu tư",
  r_end: "Tiền cuối kỳ",
  r_in: "Tiền vào",
  r_out: "Tiền ra",
  from: "Theo kế hoạch {{week}}",
  fromOlder: "Kế hoạch tuần này chưa được đồng ý — đọc từ {{week}}",
  noPlan: "Chưa có kế hoạch được đồng ý",
  rateMissing: "Không có tỷ giá NetSuite cho {{ccy}} — không tính vào Group",
  showLines: "Xem các dòng",
  hideLines: "Ẩn các dòng",
  inCcy: "Bằng {{ccy}}, số nguyên",
  h_line: "Dòng",
  h_remarks: "Ghi chú",
  memo: "tham khảo, không cộng",
  worked: "Tự tính",
  standardFormat: "{{entity}} chưa có sheet riêng trong file dự báo tiền mặt của Group — dùng các dòng chuẩn.",
  chartEnd: "Tiền cuối kỳ theo tháng — {{who}}",
  chartEndSub: "Nghìn {{base}}, tiền cuối kỳ của Group theo tháng",
  chartNet: "Thay đổi đến từ đâu — {{who}}",
  chartNetSub: "Hoạt động kinh doanh và Tài chính & Đầu tư, nghìn {{base}}",
  chartNone: "Chưa có số được đồng ý để vẽ.",
  formBeginHint: "Tiền mặt đầu {{month}}. Các tháng sau bắt đầu từ cuối kỳ tháng trước.",
  formFromPrior: "Điền sẵn từ kế hoạch {{week}} của bạn — sửa những gì đã thay đổi.",
  formNoPrior: "Chưa có kế hoạch trước để bắt đầu.",
  panelHeading: "Kế hoạch {{week}}",
  listHint: "Kế hoạch được đồng ý mới nhất của từng pháp nhân tính đến tuần này. Kế hoạch vào qua Submit (Template 2) và được đồng ý ở Approval.",
  tourGroupT: "Dự báo tiền mặt của Group",
  tourGroupB: "Kế hoạch của mọi pháp nhân theo tháng, quy đổi bằng một tỷ giá NetSuite cuối tháng cho mỗi loại tiền, tổng Group ở trên cùng. Chọn SGD, USD hoặc KRW ở trên; số tính bằng nghìn.",
  tourEntityT: "Từng pháp nhân",
  tourEntityB: "Bấm vào một pháp nhân để xem các dòng của chính nó bằng tiền tệ của nó, đúng như đã điền. Kế hoạch Reviewer chưa đồng ý thì chưa tính — dòng đó đọc kế hoạch được đồng ý gần nhất và ghi rõ là kế hoạch nào.",
  tourChartsT: "Biểu đồ",
  tourChartsB: "Tiền cuối kỳ của Group theo tháng, và thay đổi mỗi tháng đến từ đâu — Hoạt động kinh doanh so với Tài chính & Đầu tư.",
};
const zh = {
  typeWhole: "请输入完整的 {{ccy}} 金额；表中按千显示。",
  r_opFull: "现金净增加（减少）- 经营",
  r_fiFull: "现金净增加（减少）- 筹资与投资",
  total: "合计",
  ratesAsOf: "（截至 {{date}}）汇率：",
  groupHeading: "Helinox 集团现金预测",
  beginInv: "期初库存",
  tourTabsT: "每张工作表一个标签",
  tourTabsB: "与集团现金预测文件一致：先是 Group CF，然后是各法人实体按其本币和自身项目的工作表。",
  planLine: "{{week}} 的计划（周结束 {{end}}）· {{first}} – {{last}}",
  rateLine: "按 NetSuite {{date}} 汇率折算",
  rateFallback: "当天 NetSuite 无汇率的币种使用 {{week}} 的 Set up 汇率",
  groupTitle: "集团现金预测",
  unitK: "千{{base}}",
  groupNone: "截至本周尚无法人实体有已同意的计划 — Reviewer 同意后即显示预测。",
  groupCount: "{{of}} 个法人实体中 {{n}} 个已提交计划",
  r_begin: "期初现金",
  r_net: "现金净增加（减少）",
  r_op: "– 经营",
  r_fi: "– 筹资与投资",
  r_end: "期末现金",
  r_in: "现金流入",
  r_out: "现金流出",
  from: "取自 {{week}} 的计划",
  fromOlder: "本周计划尚未同意 — 取自 {{week}}",
  noPlan: "无已同意的计划",
  rateMissing: "{{ccy}} 无 NetSuite 汇率 — 未计入集团",
  showLines: "查看明细",
  hideLines: "隐藏明细",
  inCcy: "以 {{ccy}} 计，整数",
  h_line: "项目",
  h_remarks: "备注",
  memo: "备忘，不计入",
  worked: "自动计算",
  standardFormat: "{{entity}} 在集团现金预测中尚无单独工作表 — 使用标准项目。",
  chartEnd: "每月期末现金 — {{who}}",
  chartEndSub: "千{{base}}，集团每月期末现金",
  chartNet: "变动来源 — {{who}}",
  chartNetSub: "经营 与 筹资与投资，千{{base}}",
  chartNone: "尚无已同意的数据可绘制。",
  formBeginHint: "{{month}} 月初的现金。之后每月从上月期末开始。",
  formFromPrior: "已按您 {{week}} 的计划预填 — 请更新有变动的部分。",
  formNoPrior: "没有可沿用的早前计划。",
  panelHeading: "{{week}} 的计划",
  listHint: "各法人实体截至本周最新的已同意计划。计划通过 Submit（Template 2）提交，在 Approval 中同意。",
  tourGroupT: "集团现金预测",
  tourGroupB: "各法人实体的计划按月列出，每种货币按一个 NetSuite 月末汇率折算，集团合计在最上方。可在上方选择 SGD、USD 或 KRW；单位为千。",
  tourEntityT: "各法人实体",
  tourEntityB: "点击法人实体可按其本币和自身项目查看所填内容。Reviewer 尚未同意的计划不计入 — 该行读取最近一次已同意的计划并注明来源。",
  tourChartsT: "图表",
  tourChartsB: "集团每月期末现金，以及每月变动来源 — 经营 对比 筹资与投资。",
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "typeWhole": "Saisissez des {{ccy}} entiers ; la feuille affiche des milliers.",
  "r_opFull": "Variation nette de la trésorerie - Exploitation",
  "r_fiFull": "Variation nette de la trésorerie - Finance et investissement",
  "total": "Total",
  "ratesAsOf": "(au {{date}}) Taux de change :",
  "groupHeading": "Prévision de trésorerie du groupe Helinox",
  "beginInv": "Stock initial",
  "tourTabsT": "Un onglet par feuille",
  "tourTabsB": "Comme dans le classeur de prévision de trésorerie du groupe : d'abord Group CF, puis la feuille de chaque entité, dans sa propre devise et avec ses propres lignes.",
  "planLine": "Plan déposé pour {{week}} (semaine se terminant le {{end}}) · {{first}} – {{last}}",
  "rateLine": "Converti au taux NetSuite du {{date}}",
  "rateFallback": "Taux de {{week}} du paramétrage utilisé lorsque NetSuite n'en avait pas ce jour-là",
  "groupTitle": "Prévision de trésorerie du groupe",
  "unitK": "Milliers de {{base}}",
  "groupNone": "Aucune entité n'a encore de plan validé jusqu'à cette semaine — la prévision s'affichera dès qu'un Reviewer en validera un.",
  "groupCount": "{{n}} entités sur {{of}} planifiées",
  "r_begin": "Trésorerie d'ouverture",
  "r_net": "Variation nette de la trésorerie",
  "r_op": "– Exploitation",
  "r_fi": "– Finance et investissement",
  "r_end": "Trésorerie de clôture",
  "r_in": "Encaissements",
  "r_out": "Décaissements",
  "from": "Depuis le plan de {{week}}",
  "fromOlder": "Le plan de cette semaine n'est pas encore validé — lecture depuis {{week}}",
  "noPlan": "Aucun plan validé",
  "rateMissing": "Pas de taux NetSuite pour {{ccy}} — exclu du groupe",
  "showLines": "Afficher ses lignes",
  "hideLines": "Masquer ses lignes",
  "inCcy": "En {{ccy}}, montants entiers",
  "h_line": "Ligne",
  "h_remarks": "Remarques",
  "memo": "mémo, non compté",
  "worked": "Calculé",
  "standardFormat": "{{entity}} n'a pas encore de feuille propre dans la prévision de trésorerie du groupe — les lignes standard sont utilisées.",
  "chartEnd": "Trésorerie de clôture par mois — {{who}}",
  "chartEndSub": "Milliers de {{base}}, trésorerie de clôture du groupe mois par mois",
  "chartNet": "Origine de la variation — {{who}}",
  "chartNetSub": "Exploitation et Finance et investissement, milliers de {{base}}",
  "chartNone": "Rien de validé à représenter pour l'instant.",
  "formBeginHint": "La trésorerie au début de {{month}}. Chaque mois suivant commence là où le précédent se termine.",
  "formFromPrior": "Prérempli à partir de votre plan de {{week}} — mettez à jour ce qui a changé.",
  "formNoPrior": "Aucun plan antérieur comme point de départ.",
  "panelHeading": "Plan de {{week}}",
  "listHint": "Dernier plan validé de chaque entité jusqu'à cette semaine. Un plan est déposé via Soumettre (Template 2) et validé dans Approbation.",
  "tourGroupT": "La prévision de trésorerie du groupe",
  "tourGroupB": "Le plan de chaque entité, mois par mois, à un taux de fin de mois NetSuite par devise, avec le total du groupe en haut. Choisissez SGD, USD ou KRW ci-dessus ; les montants sont en milliers.",
  "tourEntityT": "Chaque entité",
  "tourEntityB": "Cliquez sur une entité pour voir ses propres lignes dans sa devise, telles qu'elle les a saisies. Un plan non encore validé par le Reviewer n'est pas pris en compte — le dernier plan validé est lu et la ligne l'indique.",
  "tourChartsT": "Graphiques",
  "tourChartsB": "La trésorerie de clôture du groupe mois par mois, et l'origine de la variation de chaque mois — Exploitation contre Finance et investissement."
};
const ja = {
  "typeWhole": "{{ccy}} の整数で入力してください。シートには千単位で表示されます。",
  "r_opFull": "現金の純増減 - 営業",
  "r_fiFull": "現金の純増減 - 財務・投資",
  "total": "合計",
  "ratesAsOf": "（{{date}} 時点）為替レート：",
  "groupHeading": "Helinox グループのキャッシュ・フォーキャスト",
  "beginInv": "期首在庫",
  "tourTabsT": "シートごとに 1 タブ",
  "tourTabsB": "グループのキャッシュ・フォーキャスト ワークブックと同様に、最初に Group CF、続いて各エンティティ自身のシートを、それぞれの通貨と項目で表示します。",
  "planLine": "{{week}}（{{end}} 終了の週）に提出された計画 · {{first}} – {{last}}",
  "rateLine": "{{date}} の NetSuite レートで換算",
  "rateFallback": "その日の NetSuite レートがない場合は、設定の {{week}} のレートを使用",
  "groupTitle": "グループのキャッシュ・フォーキャスト",
  "unitK": "{{base}} 千単位",
  "groupNone": "この週までに合意済みの計画があるエンティティはまだありません — Reviewer が合意するとフォーキャストが表示されます。",
  "groupCount": "{{of}} エンティティ中 {{n}} が計画済み",
  "r_begin": "期首現金",
  "r_net": "現金の純増減",
  "r_op": "– 営業",
  "r_fi": "– 財務・投資",
  "r_end": "期末現金",
  "r_in": "現金収入",
  "r_out": "現金支出",
  "from": "{{week}} の計画より",
  "fromOlder": "今週の計画はまだ合意されていません — {{week}} から読み取っています",
  "noPlan": "合意済みの計画なし",
  "rateMissing": "{{ccy}} の NetSuite レートがありません — グループから除外しました",
  "showLines": "明細を表示",
  "hideLines": "明細を非表示",
  "inCcy": "{{ccy}}、整数金額",
  "h_line": "明細",
  "h_remarks": "備考",
  "memo": "メモ、集計対象外",
  "worked": "算出済み",
  "standardFormat": "{{entity}} は、グループのキャッシュ・フォーキャストにまだ独自のシートがありません — 標準の項目を使用しています。",
  "chartEnd": "月別の期末現金 — {{who}}",
  "chartEndSub": "{{base}} 千単位、グループの月別期末現金",
  "chartNet": "変動の要因 — {{who}}",
  "chartNetSub": "営業と財務・投資、{{base}} 千単位",
  "chartNone": "描画できる合意済みデータはまだありません。",
  "formBeginHint": "{{month}} 初めの現金です。以降の各月は、前月の末残から始まります。",
  "formFromPrior": "{{week}} の計画から事前入力されています — 変更があった箇所を更新してください。",
  "formNoPrior": "基にできる以前の計画がありません。",
  "panelHeading": "{{week}} の計画",
  "listHint": "この週までの各エンティティの最新の合意済み計画です。計画は「提出」（Template 2）から取り込まれ、「承認」で合意されます。",
  "tourGroupT": "グループのキャッシュ・フォーキャスト",
  "tourGroupB": "各エンティティの計画を月別に、通貨ごとに 1 つの NetSuite 月末レートで換算し、上部にグループ合計を表示します。上の SGD、USD、KRW から選択してください。数値は千単位です。",
  "tourEntityT": "各エンティティ",
  "tourEntityB": "エンティティを押すと、入力された内容がそのエンティティ自身の通貨で表示されます。Reviewer が未合意の計画は対象外で、直近の合意済みの計画が読み取られ、その行に明記されます。",
  "tourChartsT": "グラフ",
  "tourChartsB": "グループの月別期末現金と、各月の変動の要因（営業と財務・投資の比較）です。"
};

const dictionary = { ns: 'xCashMp', en, ko, vi, zh, fr, ja };
export default dictionary;
